define.alias("shared/components/shared/social/instagram-modal", "settings/components/shared/social/instagram-modal");